import React, { useEffect, useState } from "react";
import { X, MailWarning, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function TopBanners() {
  const { user } = useAuth();
  const [dismissVerify, setDismissVerify] = useState(() => sessionStorage.getItem("paknet_dismiss_verify") === "1");
  const [installEvt, setInstallEvt] = useState(null);
  const [dismissInstall, setDismissInstall] = useState(() => localStorage.getItem("paknet_dismiss_install") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener("beforeinstallprompt", h);
    return () => window.removeEventListener("beforeinstallprompt", h);
  }, []);

  const resend = async () => {
    try {
      await api.post("/auth/resend-verification");
      toast.success("تصدیقی ای میل بھیج دی گئی");
    } catch { toast.error("ناکام"); }
  };

  const install = async () => {
    if (!installEvt) return;
    installEvt.prompt();
    const r = await installEvt.userChoice;
    if (r.outcome === "accepted") toast.success("PakNet انسٹال ہو گیا");
    setInstallEvt(null);
  };

  return (
    <>
      {user && !user.email_verified && !dismissVerify && (
        <div className="bg-amber-50 border-b border-amber-200 text-amber-900" data-testid="verify-banner">
          <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
            <MailWarning size={16} className="text-amber-700 shrink-0" />
            <span className="urdu-naskh flex-1">آپ کی ای میل ابھی تک تصدیق شدہ نہیں۔ مکمل رسائی کے لیے تصدیق کریں۔</span>
            <Button size="sm" variant="outline" onClick={resend} className="urdu-naskh h-7" data-testid="verify-resend">
              دوبارہ بھیجیں
            </Button>
            <button onClick={() => { sessionStorage.setItem("paknet_dismiss_verify", "1"); setDismissVerify(true); }} className="text-amber-700 hover:text-amber-900" title="بند کریں">
              <X size={14} />
            </button>
          </div>
        </div>
      )}
      {installEvt && !dismissInstall && (
        <div className="bg-primary/5 border-b border-primary/20 text-primary-foreground" data-testid="install-banner">
          <div className="max-w-6xl mx-auto px-4 py-2 flex items-center gap-3 text-sm text-primary">
            <Download size={16} className="shrink-0" />
            <span className="urdu-naskh flex-1">PakNet کو اپنے فون پر ایپ کی طرح انسٹال کریں</span>
            <Button size="sm" onClick={install} className="urdu-naskh h-7 bg-primary" data-testid="install-btn">انسٹال کریں</Button>
            <button onClick={() => { localStorage.setItem("paknet_dismiss_install", "1"); setDismissInstall(true); }} className="text-primary/70 hover:text-primary" title="بند کریں">
              <X size={14} />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
